/**
 * Return values for error handler generators.
 *
 * Each error handler in the chain must return one of these two values:
 *
 * - HANDLED : The handler dealt with this error completely. The chain stops
 *             here and no subsequent handlers (including the default) are run.
 *
 * - SKIP    : The handler does not apply to this error. Pass it to the next
 *             handler in the chain unchanged.
 *
 * Note: a CONTINUE sentinel was previously exported but removed because
 * runHandlerChain treated it identically to SKIP, making the distinction
 * misleading. Use SKIP for "this handler doesn't apply" in all cases.
 */
export const HANDLED = 'handled'
export const SKIP = 'skip'
